const nonImmutableAT = {
    'SV/setMapData': 'SV/setMapData',
    'DB/setMapData': 'DB/setMapData',
    'nonIM/reset': 'nonIM/reset',
}


export const setMapDataSV = (mapData) => ({
    type: nonImmutableAT['SV/setMapData'],
    mapData,
});

export const setMapDataDB = (mapData) => ({
    type: nonImmutableAT['DB/setMapData'],
    mapData,
});

export const resetNonIM = () => ({
    type: nonImmutableAT['nonIM/reset'],
});


const initState = {
    SVmapData: null,
    DBmapData: [],
};


const nonIMReducer = (state=initState, action) => {

    switch(action.type){

        case nonImmutableAT['SV/setMapData']:
            const stateSV = {...state, ...{}};
            const mapDataSV = action.mapData || [];

            stateSV.SVmapData = mapDataSV;

            return {...state, ...stateSV};

        case nonImmutableAT['DB/setMapData']:
            const stateDB = {...state, ...{}};
            const mapDataDB = action.mapData || [];

            stateDB.DBmapData = mapDataDB;

            return {...state, ...stateDB};

        case nonImmutableAT['nonIM/reset']:
            return initState;

        default:
            return state;
    }
};


export default nonIMReducer;
